import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { api } from "../api/client";

const CATEGORIES = [
  { key: "", label: "Toutes" },
  { key: "actualite", label: "Actualités" },
  { key: "conseil_municipal", label: "Conseils municipaux" },
  { key: "arrete", label: "Arrêtés" },
  { key: "manifestation", label: "Manifestations" },
  { key: "vie_scolaire", label: "Vie scolaire" },
  { key: "information", label: "Informations" },
];

const CAT_LABELS = {
  actualite: "Actualité", conseil_municipal: "Conseil municipal",
  arrete: "Arrêté", manifestation: "Manifestation",
  vie_scolaire: "Vie scolaire", information: "Information",
};

function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", {
      day: "numeric", month: "long", year: "numeric",
    });
  } catch { return iso; }
}

const UPLOADS = "/uploads/actualites/";

export default function Actualites() {
  const [cat, setCat] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const q = cat ? `/actualites?categorie=${cat}&limit=50` : "/actualites?limit=50";
      const d = await api.get(q);
      setItems(d.items || []);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [cat]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="container">
      <h1>Actualités</h1>
      <p className="muted mb-3">Les nouvelles, décisions et événements de la commune.</p>

      <div className="tabs">
        {CATEGORIES.map((c) => (
          <button key={c.key}
                  className={`tab ${cat === c.key ? "active" : ""}`}
                  onClick={() => setCat(c.key)}>
            {c.label}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="muted">Chargement…</p>
      ) : items.length === 0 ? (
        <p className="muted">Aucune actualité dans cette catégorie.</p>
      ) : (
        <div className="actu-grid">
          {items.map((a) => (
            <article key={a.id} className="actu-card">
              {a.image_principale ? (
                <img className="actu-card-img" src={UPLOADS + a.image_principale} alt={a.titre} />
              ) : (
                <div className="actu-card-noimg">La Chapelle-Saint-Fray</div>
              )}
              <div className="actu-card-body">
                <div>
                  <span className={`badge badge-${a.categorie}`}>
                    {CAT_LABELS[a.categorie] || a.categorie}
                  </span>
                  {a.epingle ? <span className="badge badge-epingle">Épinglé</span> : null}
                </div>
                <h3><Link to={`/actualites/${a.slug}`}>{a.titre}</Link></h3>
                <div className="actu-card-date">{formatDate(a.date_publication)}</div>
                {a.chapeau && <p className="actu-card-chapeau">{a.chapeau}</p>}
                <Link to={`/actualites/${a.slug}`}>Lire la suite →</Link>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
